// extracted by mini-css-extract-plugin
export default {"header":"edit_certificate-module___header___ab84cfc6","title":"edit_certificate-module___title___d7323924"};